import { useFormContext } from 'react-hook-form';
import { SearchableSelect } from '@/components/common';
import { useVehicleModels } from '@/hooks/useVehicles';
import type { VehicleModel } from '@/services/vehicles';
import type { MotorQuoteFormData } from '../../schema';

export function ModelStep() {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext<MotorQuoteFormData>();

  const makeId = watch('make_id');
  const makeName = watch('make_name');
  const modelId = watch('model_id');
  const { data: models, isLoading } = useVehicleModels(makeId);

  const options = (models ?? []).map((m: VehicleModel) => ({ value: m.id, label: m.name }));

  const handleChange = (id: string) => {
    const model = (models ?? []).find((m: VehicleModel) => m.id === id);
    setValue('model_id', id, { shouldValidate: true, shouldDirty: true });
    setValue('model_name', model?.name ?? '', { shouldValidate: false });
    // Cascade reset: a new model invalidates any previously chosen variant.
    setValue('variant_id', '', { shouldValidate: false });
    setValue('variant_name', '', { shouldValidate: false });
    setValue('fuel_type', '', { shouldValidate: false });
  };

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Model</h2>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-1 mb-6">
        Select the vehicle model{makeName ? ` for ${makeName}` : ''}.
      </p>
      <div className="sm:max-w-sm">
        <SearchableSelect
          id="model_id"
          label="Model"
          options={options}
          value={modelId}
          onChange={handleChange}
          placeholder={isLoading ? 'Loading...' : 'Select model'}
          error={errors.model_id?.message}
          disabled={!makeId}
          required
        />
      </div>
    </div>
  );
}
